// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2Ev1w","question":"Question_question__3143U","description":"Question_description__17TCI"};